<template>
	<v-container fluid>
		<v-card style="border-radius: 20px; ">
			<v-row>
				<div class="title-displays" style="padding-top: 15px; padding-left: 15px">
					Projetos
				</div>
				<v-spacer></v-spacer>
				<div class="d-flex align-center" style="gap: 16px">
					<v-btn-toggle
						v-model="viewMode"
						mandatory
						dense
						class="mr-4"
					>
						<v-btn small value="table">
							<v-icon>mdi-table</v-icon>
						</v-btn>
						<v-btn small value="kanban">
							<v-icon>mdi-view-column</v-icon>
						</v-btn>
					</v-btn-toggle>
					<v-btn style="padding-top: 15px; padding-left: 15px" color="primary" text
						@click="openDialog()" :disabled="is_loading">
						<v-icon>add</v-icon>
						Novo Projeto
					</v-btn>
					<v-btn 
						v-if="getCurrentUserRank !== 'Franqueado'"
						style="padding-top: 15px; padding-left: 15px" 
						color="secondary" 
						text
						@click="navigateToDashboard()" 
						:disabled="is_loading">
						<v-icon>mdi-chart-line</v-icon>
						Dashboard
					</v-btn>
					<v-btn 
						v-if="getCurrentUserRank === 'Super Admin' || getCurrentUserRank === 'Admin'"
						style="padding-top: 15px; padding-left: 15px" 
						color="secondary" 
						text
						@click="openProjectSettings()" 
						:disabled="is_loading">
						<v-icon>mdi-cog</v-icon>
					</v-btn>
				</div>
			</v-row>
			<v-spacer></v-spacer>
			<!-- Busca -->
			<v-row dense>
				<v-col cols="10">
					<v-text-field prepend-icon="search" label="Busca" v-model="searchField" />
				</v-col>
				<v-col cols="2">
					<v-select hint="Buscar nessa coluna" persistent-hint v-model="searchOptionSelected"
						:items="filteredSearchOptions" single-line />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="12">
					<div class="chip-container">
						<div class="chip-wrapper" v-for="(step, index) in project_steps_list">
							<v-chip class="ma-2" :color="isSelectedChip(step.id) ? 'blue darken-2' : 'clay'"
									text-color="white" @click="selectProjectTypeFilter(step.id)">
								<img
									style="width: 30px;"
									:src="step.icon"
									alt="Step Icon"
									class="step-icon"
								/>
								{{ step.name }}
							</v-chip>
						</div>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="d-flex align-center justify-end" style="gap: 16px;">
					<v-menu
						v-model="statusFilterMenu"
						:close-on-content-click="false"
						offset-y
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-bind="attrs"
								v-on="on"
								:color="selectedStatusColor ? selectedStatusColor : 'grey lighten-1'"
								:outlined="!selectedStatusColor"
								:disabled="is_loading"
								class="filter-btn"
							>
								<v-icon left>mdi-filter</v-icon>
								{{ selectedStatusColor ? 'Filtro Ativo' : 'Filtrar por Status' }}
							</v-btn>
						</template>
						<v-card min-width="300">
							<v-list>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title class="text-h6">
											Filtrar por Status
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-divider></v-divider>
								<v-list-item
									v-for="status in statusColors"
									:key="status.color"
									@click="selectStatusColor(status.color)"
									:class="{ 'selected-status': selectedStatusColor === status.color }"
								>
									<v-list-item-icon>
										<v-icon :color="status.color">
											{{ selectedStatusColor === status.color ? 'mdi-check-circle' : 'mdi-circle' }}
										</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>{{ status.name }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-divider></v-divider>
								<v-list-item @click="selectStatusColor(null)" v-if="selectedStatusColor">
									<v-list-item-icon>
										<v-icon>mdi-close</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Limpar Filtro</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-card>
					</v-menu>

					<v-btn
						@click="startDateCalendar()"
						:color="startDatePicker.length ? 'primary' : 'grey lighten-1'"
						:outlined="!startDatePicker.length"
						:disabled="is_loading"
						class="filter-btn"
					>
						<v-icon left>mdi-calendar-range</v-icon>
						{{ formattedDateRange }}
						<v-icon right v-if="startDatePicker.length" small class="ml-2" @click.stop="clearDateFilter">
							mdi-close-circle
						</v-icon>
					</v-btn>
				</v-col>
			</v-row>

			<!-- Table View -->
			<v-data-table
				v-if="viewMode === 'table'"
				multi-sort
				:headers="filteredHeaders"
				:items="getItems"
				no-data-text="Sem Projetos para exibir"
				style="border-radius: 20px"
				:loading="is_loading"
			>
				<template v-slot:item.project_name="{ item }">
					{{item.project_name}}
				</template>
				<template v-slot:item.steps="{ item }">
					{{checkCurrentStep(item.steps)}}
				</template>
				<template v-slot:item.date_formatted_franchisee="{ item }">
					{{formatDate(item.date_formatted_franchisee)}}
				</template>
				<template v-slot:item.date_formatted_adm="{ item }">
					{{formatDate(item.date_formatted_adm)}}
				</template>
				<template v-slot:item.created_at_formatted="{ item }">
					{{formatDate(item.created_at_formatted)}}
				</template>
				<template v-slot:item.lastLogMessage="{ item }">
					<v-chip
							class="ma-1"
							:color="getChipColor(item.currentStatusFranchisee, item.lastLogMessage)" text-color="white">
							{{ getChipStatus(item.currentStatusFranchisee, item.lastLogMessage) }}
					</v-chip>
				</template>
				<template v-slot:item.currentStatusADM="{ item }">
					<v-chip
							class="ma-1"
							:color="getChipColor(item.currentStatusADM, item.lastLogMessage)" text-color="white">
							{{ getChipStatus(item.currentStatusADM, item.lastLogMessage) }}
					</v-chip>
				</template>

				<template v-slot:item.has_message="{ item }">
						<v-icon 
							v-if="item.has_message"
							:loading="true" 
							:disabled="isDisabled('delete', item)" 
							@click="openMessageDialog(item.id_doc)"  
							color="warning"> mdi-chat-alert </v-icon>
						<v-icon 
							v-else 
							:disabled="isDisabled('delete', item)" 
							@click="openMessageDialog(item.id_doc)"
							color="primary"> mdi-chat-plus </v-icon>
				</template>

				<template v-slot:item.actions="{ item }">
					<v-btn @click="navigateProject(item)" v-ripple style="margin-right: 5px;" :loading="is_loading"
						:disabled="is_loading || loadingAction('edit')">
						<v-icon small color="primary"> mdi-eye </v-icon>
					</v-btn>
				</template>
			</v-data-table>

			<!-- Kanban View -->
			<ProjectKanban
				v-else
				:projects="getItems"
				:status-colors="statusColors"
				:loading="is_loading"
				:get-chip-color="getChipColor"
				:get-chip-status="getChipStatus"
				:format-date="formatDate"
				:is-franchisee="isFranchisee"
				:enable-drag-and-drop="false"
				@step-change="handleStepChange"
				@navigate="navigateProject"
				@open-message="openMessageDialog"
				@update-projects="updateProjects"
			/>
		</v-card>

		<template>
			<v-row justify="center">
				<v-dialog v-model="dialog" persistent max-width="450">
					<v-form ref="newProjectForm" v-model="isValidForm" lazy-validation>
						<v-card>
							<v-card-title class="text-h5">
								<h5>Adicionar um Novo Projeto</h5>
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col>
										<v-text-field v-model="form.project_name" label="Nome do Projeto" :counter="64"
											required :rules="ruleString(true, 64)"
											:disabled="loadingNewProject"></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4">
										<v-select v-model="type_lead_document_selected" :items="type_lead_documents"
											label="Tipo do Documento" :disabled="loadingNewProject"></v-select>
									</v-col>
									<v-col cols="8">
										<v-text-field v-model="form.lead_document"
											:label="`Digite ${['CPF', 'CNPJ'].includes(type_lead_document_selected) ? `o` : `a `} ${type_lead_document_selected} do Cliente`"
											v-mask="type_lead_documents_masks[type_lead_document_selected]"
											:rules="type_lead_document_selected == 'CPF' ? ruleCPF(true) : type_lead_document_selected == 'CNPJ' ? ruleCNPJ(true) : ruleRequired()"
											:disabled="loadingNewProject"></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-autocomplete label="Franqueado" v-if="getCurrentUserRank !== 'Franqueado'"
											persistent-hint v-model="form.id_franchisee"
											:items="project_franchisee_list" item-text="name" return-object single-line
											:disabled="loadingNewProject" :rules="ruleRequired()"></v-autocomplete>
									</v-col>
								</v-row>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="green darken-1" text @click="closeDialog" :disabled="loadingNewProject">
									Cancelar
								</v-btn>
								<v-btn color="green darken-1" text :loading="loadingNewProject" @click="createProject">
									Criar
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</v-dialog>
			</v-row>
		</template>

		<Propecting 
			v-if="openProspection" 
			:openModal="openProspection" 
			:idLead="null" 
			:closeFunc="closeFunc"
			:newLead="newLead" 
		/>

		<v-dialog v-model="startDateDialog" max-width="338px" @click="startDateDialog = !startDateDialog">
			<v-card>
				<v-card-title>
					<span>Intervalo de Datas</span>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-date-picker 
						class="date-picker-height" 
						v-model="startDatePicker" 
						type="date" 
						locale="pt-br"
						:max="maxStartDate" 
						@change="(newDate) => selectDateCalendar(newDate)" 
						range
					></v-date-picker>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" text @click="startDateDialog = !startDateDialog">
						Fechar
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn 
						color="red" 
						v-if="startDatePicker.length" 
						text 
						@click="() => {
							startDatePicker = []
							startDateDialog = !startDateDialog
						}"
					>
						Limpar Seleção
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<ProjectMessagesDialog
			v-model="show_messages_dialog"
			:project-id="selected_project.id_doc"
			:loading="is_loading"
			@dialog-closed="updateProjectMessageStatus"
		/>

		<!-- Modal de Configurações de Projetos -->
		<ProjectSettingsModal 
			:show="show_project_settings"
			:franchiseeList="franchisee_list"
			@close="closeProjectSettings"
		/>

	</v-container>
</template>

<script>
import ProjectsScript from "./ProjectsScript.js";
import ProjectKanban from "@/components/Projects/ProjectKanban.vue";
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper";
import ProjectSettingsModal from "./ProjectSettingsModal.vue";

export default {
	components: {
		ProjectKanban,
		ProjectSettingsModal
	},
	extends: ProjectsScript,
	data() {
		return {
			...ProjectsScript.data(),
			viewMode: 'kanban',
			show_project_settings: false
		}
	},
	methods: {
		...ProjectsScript.methods,
		async handleStepChange({ projectId, newStep }) {
			try {
				this.is_loading = true;
				// Implement your step update logic here
				await this.updateProjectStep(projectId, newStep);
				showSuccessSnackBar('Etapa atualizada com sucesso');
			} catch (error) {
				showErrorSnackBar('Erro ao atualizar etapa');
				console.error('Error updating step:', error);
			} finally {
				this.is_loading = false;
			}
		},
		openProjectSettings() {
			this.show_project_settings = true;
		},
		closeProjectSettings() {
			this.show_project_settings = false;
		},
		navigateToDashboard() {
			this.$router.push('/projects/dashboard');
		}
	}
};
</script>

<style scoped>
.title-displays {
	font-size: 25px;
	padding-top: 8px;
	padding-bottom: 8px;
}

.chip-container {
	display: flex;
	overflow-x: auto;
	/* Enables horizontal scrolling */
	white-space: nowrap;
	/* Prevents wrapping of chips */
}

.chip-wrapper {
	display: inline-block;
	/* Ensures chips stay inline */
}

/* Optional: Add smooth scrolling behavior */
.chip-container::-webkit-scrollbar {
	height: 6px;
	/* Adjust scrollbar height */
}

.chip-container::-webkit-scrollbar-thumb {
	background: #888;
	/* Color of the scrollbar */
	border-radius: 4px;
}

.chip-container::-webkit-scrollbar-thumb:hover {
	background: #555;
	/* Color on hover */
}

.chip-user {
  border: none;
  padding: 5px;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  background-color: #000;
  margin-top: 10px;
}

.chip-user .v-icon {
  font-size: 28px;
}

.span-img-user {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.img-user {
  width: 100%;
  height: 100%;
  object-fit: fill;
  display: block;
}

.sender-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 200px;
}

.sender-name {
  font-size: 1rem;
  color: #2c3e50;
  margin-bottom: 4px;
  line-height: 1.2;
}

.message-meta {
  font-size: 0.85rem;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.2;
}

.updated-at-formatted {
  font-weight: 500;
  border: 2px solid darkgray;
  border-radius: 5px;
  padding: 2px;
  margin-top: -3px;
  user-select: none
}

.selected-status {
  background-color: rgba(0, 0, 0, 0.05);
}

.filter-btn {
  min-width: 200px;
  text-transform: none;
  letter-spacing: normal;
  height: 40px;
}

.filter-btn .v-icon.mdi-close-circle {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.filter-btn .v-icon.mdi-close-circle:hover {
  opacity: 1;
}

.messages-dialog {
  border-radius: 12px;
}

.messages-card {
  border-radius: 12px;
  overflow: hidden;
}

.messages-header {
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
  padding: 16px 24px;
}

.messages-content {
  background-color: #f5f5f5;
  min-height: 500px;
  max-height: 80vh;
  overflow-y: auto;
}

.new-message-section {
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.message-textarea {
  border-radius: 8px;
}

.send-button {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
}

.message-card {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.message-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
}

.message-header {
  position: relative;
}

.message-time {
  color: #666;
}

.message-edited {
  color: #666;
  font-size: 0.85rem;
}

.message-content {
  color: #2c3e50;
  line-height: 1.5;
}

.message-text {
  white-space: pre-wrap;
  word-break: break-word;
}

.action-button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.action-button:hover {
  opacity: 1;
}

.dropdown-message {
  position: absolute;
  right: 0;
  top: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 180px;
  margin-top: 4px;
}

.dropdown-item {
  transition: background-color 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.response-button {
  text-transform: none;
  font-weight: 500;
  min-width: auto;
}

.response-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

.comments-section {
  margin-left: 16px;
  border-left: 2px solid #e0e0e0;
  padding-left: 16px;
}

.comment-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

.comment-header {
  margin-bottom: 8px;
}

.comment-content {
  color: #2c3e50;
  line-height: 1.5;
}

.comment-text {
  white-space: pre-wrap;
  word-break: break-word;
}

.edit-textarea {
  border-radius: 8px;
}

/* Scrollbar styling */
.messages-content::-webkit-scrollbar {
  width: 8px;
}

.messages-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.messages-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.messages-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.message-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.comment-actions {
  position: relative;
}

.v-btn-toggle {
	border-radius: 8px;
	overflow: hidden;
}

.v-btn-toggle .v-btn {
	border: none !important;
	opacity: 0.7;
}

.v-btn-toggle .v-btn.v-btn--active {
	opacity: 1;
	background-color: rgba(var(--v-theme-primary), 0.1);
}
</style>